import React from 'react';
import {Redirect} from 'react-router';
import {Recht} from 'shared-types';

import store from '../../store/store';

export function hasRight(authUserReducer, right) {
    return (
        authUserReducer &&
        authUserReducer.beheerder &&
        authUserReducer.beheerder.rol &&
        authUserReducer.beheerder.rol.rechten &&
        (authUserReducer.beheerder.rol.rechten.includes(right) ||
            authUserReducer.beheerder.rol.rechten.includes(Recht.IS_SUPERUSER))
    );
}

export function isUitgeverAccount(authUserReducer) {
    if (!authUserReducer?.beheerder || authUserReducer?.beheerder?.uitgever) {
        return true;
    }
    return false;
}

export function isUitgever(authUserReducer, uitgeverName) {
    const uitgeverNameOfAdministrator = authUserReducer?.beheerder?.uitgever?.name?.toLowerCase();
    return uitgeverName && uitgeverNameOfAdministrator === uitgeverName?.toLowerCase();
}

export const withPermissions = (requiredRight, excludeWithRight) => Component => {
    const hasPermissions = () => {
        const {authUserReducer} = store.getState();

        if (!authUserReducer.loading && authUserReducer.beheerder) {
            if (excludeWithRight && isUitgeverAccount(authUserReducer)) {
                return authUserReducer.beheerder && hasRight(authUserReducer, requiredRight) && !hasRight(authUserReducer, excludeWithRight);
            } else {
                return authUserReducer.beheerder && hasRight(authUserReducer, requiredRight);
            }
        } else {
            return true;
        }
    };

    const protectedComponent = class extends React.Component {
        render() {
            return hasPermissions() ? <Component {...this.props} /> : <Redirect to={'/access-denied'} />;
        }
    };
    protectedComponent.requiredRight = requiredRight;
    protectedComponent.excludeWithRight = excludeWithRight;
    return protectedComponent;
};
